module.exports = __webpack_public_path__ + "img/timer-green.efe63491.svg";